<template>
  <ModalWindow
    v-model:visible="localVisible"
    class="text-center"
    :show-title="false"
    @on-close="close"
  >
    <div class="modal-alert">
      <div
        class="modal-alert__icon"
        :class="type"
      >
        <IconAttention v-if="type === 'warning'" />

        <IconCheckCircle v-if="type === 'success'" />
      </div>
      {{ text }}
      <RouterLink
        v-if="link"
        :to="link"
      >
        {{ textLink }}
      </RouterLink>
    </div>

    <template #footer>
      <ModalWindowNavigation :items-count="1">
        <BaseButton
          uppercase
          @click="close"
        >
          {{ $t('base.ok') }}
        </BaseButton>
      </ModalWindowNavigation>
    </template>
  </ModalWindow>
</template>

<script>
import ModalWindow from '@/components/modals/ModalWindow.vue'
import BaseButton from '@/components/button/BaseButton.vue'
import IconAttention from '@/components/icons/IconAttention.vue'
import IconCheckCircle from '@/components/icons/IconCheckCircle.vue'
import ModalWindowNavigation from '@/components/modals/ModalWindowNavigation.vue'

export default {
  name: 'ModalAlert',
  components: {
    ModalWindowNavigation,
    IconCheckCircle,
    IconAttention,
    ModalWindow,
    BaseButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    link: {
      type: [String, Object],
      default: null
    },
    textLink: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning',
      validator(value) {
        return ['warning', 'success'].includes(value)
      }
    }
  },
  emits: ['close', 'update:visible'],
  computed: {
    localVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    close() {
      this.localVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.modal-alert {
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  font-size: var(--font-size-body-1);
  line-height: var(--leading-180);
  font-weight: var(--weight-normal);

  .modal-alert__icon {
    display: grid;
    place-items: center;

    &.success {
      color: var(--color-green-600);
    }

    &.warning {
      color: var(--color-orange-500);
    }

    svg {
      width: 65px;
      height: 65px;
    }
  }

  a {
    color: var(--color-zinc-700);
    text-decoration: underline;
  }
}
</style>
